const PageStruct = {
    id: 'wishlist',
    useLayout: true,
    children: [{ id: 'wishlist', order: 1, dataKey: 'wishlist' }]
};

export default PageStruct;
